import React from "react";
import HomeContainer1 from "./HomeContainer1";
import HomeContainer2 from "./HomeContainer2";

const HomeContainer = () => {
  return (
    <div>
      <HomeContainer1 />
      <HomeContainer2 />
    </div>
  );
};

export default HomeContainer;
